module.exports = __webpack_public_path__ + "static/media/filter.f5be5d1c.svg";